/**
 * Animates surfstr-band comparison bars once when scrolled into view.
 */
class SurfstrBandCompare {
  #observer;

  constructor() {
    const roots = document.querySelectorAll("[data-surfstr-compare]");
    if (!roots.length) return;

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      for (const root of roots) root.classList.add("is-in-view");
      return;
    }

    this.#observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.classList.add("is-in-view");
          this.#observer.unobserve(entry.target);
        }
      },
      { threshold: 0.2, rootMargin: "0px 0px -8% 0px" }
    );

    for (const root of roots) this.#observer.observe(root);
  }
}

new SurfstrBandCompare();
